import { FC, ReactNode } from 'react';

type TableProps = {
  className?: string;
  content: ReactNode;
};

const Table: FC<TableProps> = ({ className, content }) => (
  <div className="card card-bordered card-preview">
    <table className={className || 'table table-striped-inverse custom-table'}>
      {content}
    </table>
  </div>
);

export default Table;
